import {
  formikSelectFieldRoundedControlStyle,
  formikSelectFieldRoundedMenuStyle,
} from 'components/FormikSelectFieldLegacy/styles';
import type { CSSObjectWithLabel } from 'react-select';

export const reactSelectStyles = {
  control: (base: CSSObjectWithLabel) => ({
    ...base,
    ...formikSelectFieldRoundedControlStyle,
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    ...formikSelectFieldRoundedMenuStyle,
  }),
};
